import { addMinutes, setHours, setMinutes, subMinutes } from "date-fns";
import { ceilMeasure } from "../constants";
import { getHeightFromDate } from "./getDataFromDate";

export const getRoundedValue = (value: number, startValue: number, isHeight?: boolean) => {
  const num = startValue % (15 / ceilMeasure);

  const roundedValue = Math.round((value - (1 / ceilMeasure)) / (15 / ceilMeasure)) * ((15) / ceilMeasure) + (isHeight ? 0 : num);

  return (roundedValue < 0 && !isHeight) ? 0 : roundedValue;
};

export const getTimeValues = (start: Date, end: Date, top: number, height: number, startHour: number) => {
  const startHours = ((((top) / 60) * ceilMeasure + 0.01) % 24) + startHour;

  const startMinutes = Math.floor(((top) * ceilMeasure) % 60);
  const startDate = setMinutes(setHours(start, startHours), startMinutes);

  const endHours = ((((top + height) / 60) * ceilMeasure + 0.01) % 24) + startHour;
  const endMinutes = Math.round(((top + height) * ceilMeasure) % 60);

  const isWrongTime = (Math.floor(endHours) === 24 && endMinutes >= 0) || (Math.floor(endHours) === 0 && (height >= 68 || (height < 68 && Math.floor(startHour) > 0)));

  const endDate = setMinutes(setHours(end, isWrongTime ? 23 : endHours), isWrongTime ? 59 : endMinutes);

  return {
    startDate,
    endDate: startDate > subMinutes(endDate, 15)
      ? addMinutes(startDate, 15)
      : endDate
  };
};

/** true - встреча продолжительностью 15мин  */
export const checkIsMeetingFor15Min = (startDate: Date, endDate: Date) => (
  (getHeightFromDate(startDate, endDate) * ceilMeasure) === 15
);

export const checkIsMetingInOneLine = (startDate: Date, endDate: Date) => (
  getHeightFromDate(startDate, endDate) < 30
);
